import React from 'react';
import PropTypes from 'prop-types';
import TextSmall from '../TextSmall';

import {
  StyledEducation,
  StyledList,
  StyledElements,
  StyledCertificate,
  StyledParagraph,
  StyledBetweenDay,
  StyledBatch,
  StyledDash,
  StyleEditIcon
} from './style';

import { Pencil } from '../../../../assets/images/index';

const Resume = (dataEducations, limit) => (
  <StyledList>
    {dataEducations.slice(0, limit).map(item => (
      <StyledElements key={item.degree + item.schoolName}>
        <StyledBatch>
          <StyledCertificate>{item.degree}</StyledCertificate>
          <StyledBetweenDay format="YYYY">{item.startDate}</StyledBetweenDay>
          <StyledDash>-</StyledDash>
          <StyledBetweenDay format="YYYY">{item.endDate}</StyledBetweenDay>
        </StyledBatch>
        <StyledParagraph>{item.schoolName}</StyledParagraph>
      </StyledElements>
    ))}
  </StyledList>
);

const Education = ({
  className,
  dataEducations,
  limit,
  clickEditIcon,
  onEditMode
}) =>
  dataEducations.length !== 0 ? (
    <StyledEducation
      className={className}
      title="Mi formación"
      more={dataEducations && dataEducations.length > limit}
      moreInfo={Resume(
        dataEducations,
        dataEducations ? dataEducations.length : 0
      )}
    >
      {onEditMode && (
        <StyleEditIcon
          svg={Pencil}
          size="m"
          color="dark"
          hover
          onClick={clickEditIcon}
        />
      )}
      {Resume(dataEducations, limit)}
    </StyledEducation>
  ) : (
    <StyledEducation className={className} title="Mi formación">
      {onEditMode && (
        <StyleEditIcon
          svg={Pencil}
          size="m"
          color="dark"
          hover
          onClick={clickEditIcon}
        />
      )}
      <TextSmall>Parece que aún no hay formación para mostrar.</TextSmall>
    </StyledEducation>
  );

Education.propTypes = {
  className: PropTypes.string,
  dataEducations: PropTypes.arrayOf(
    PropTypes.shape({
      degree: PropTypes.string,
      endDate: PropTypes.string,
      schoolName: PropTypes.string,
      startDate: PropTypes.string
    })
  ),
  limit: PropTypes.number,
  clickEditIcon: PropTypes.func,
  onEditMode: PropTypes.bool
};

export default Education;
